import { TOLT_PUBLIC_KEY } from 'consts';
import _ from 'lodash';

declare global {
  interface Window {
    tolt: any;
    tolt_data: any;
    tolt_referral: any;
  }
}

export const recordLeadForTolt = ({ email }: { email: string }) => {
  if (!_.isEmpty(TOLT_PUBLIC_KEY) && window.tolt_referral) {
    window.tolt.signup(email);
  }
};
